import { Navigate, Route, Routes } from "react-router-dom";
import MetatagChecker from "pages/MetatagChecker";
import Header from "components/Header";
import Footer from "components/Footer";
import './styles/global-styles.scss';
import "assets/css/layout/App.scss";

const App = (): JSX.Element => {
  return (
    <div className='app'>
      <Header />
      <main className='app-content'>
        <Routes>
          <Route path="/" element={ <Navigate to="/nl" replace={ true } /> } />
          <Route path="/:language" element={ <MetatagChecker /> } />
        </Routes>
      </main>
      <Footer />
    </div>
  )
};

export default App;
